<template>
  <div class="poi-list-container">
    <div
      class="poi-item"
      v-for="poi in pois"
      :key="poi.id"
      @click="
        () => {
          handleClickPoi(poi);
        }
      "
    >
      <div class="location-icon">
        <img src="@assets/images/ic_location_simple.svg" />
      </div>
      <div class="poi-info">
        <div
          class="poi-name"
          v-html="calcHightlightString(poi.name, highlightString)"
        ></div>
        <div class="poi-address">
          <span class="city-name">{{ poi.cityname }}</span
          ><span class="area-name">{{ poi.adname }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default _extend({
  name: 'PoiList',
  props: {
    pois: {
      type: Array,
      default: () => []
    },
    highlightString: {
      type: String,
      default: () => '',
      required: false
    }
  },
  data() {
    return {
      // Your component data here
    };
  },
  methods: {
    calcHightlightString(str, highlightString) {
      if (!highlightString) {
        return str;
      }
      let resultArr = str.split('');
      const highlightSet = new Set(highlightString.split(''));
      resultArr = resultArr.map(char =>
        highlightSet.has(char)
          ? `<font style="color: #4981F2">${char}</font>`
          : char
      );
      return resultArr.join('');
    },
    handleClickPoi(poi) {
      this.$emit('selectPoi', poi);
    }
  }
});
</script>

<style scoped lang="scss">
.poi-list-container {
  margin: 16px 16px 0 16px;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 0px 16px 0 rgba(0, 0, 0, 0.08);
  flex: 1;
  overflow: auto;
  width: 358px;
  .poi-item {
    min-height: 72px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    &:active {
      background-color: #f5f5f5;
    }
    .location-icon {
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
    .poi-info {
      flex: 1;
      border-bottom: 1px solid #eeeeee;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 14px 0;
      .poi-name {
        font-size: 18px;
        color: #333;
        line-height: 22px;
      }
      .poi-address {
        font-size: 13px;
        color: #999;
        .city-name {
          margin-right: 4px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/business/views/ActiveForm/PoiList/PoiList.vue